import { render, staticRenderFns } from "./SprintDefect.vue?vue&type=template&id=73b9ef4b"
import script from "./SprintDefect.vue?vue&type=script&lang=js"
export * from "./SprintDefect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports